const WHATSAPP_MENTION =
  /\[@((?:\\.|[^\]])+)\]\(mention:\/\/whatsapp\/([^/)]+)\/((?:[^()]|\([^()]*\))+?)\)/g;

export function parseWhatsappMentions(content = '') {
  return Array.from(content.matchAll(WHATSAPP_MENTION)).flatMap(match => {
    try {
      return [
        {
          start: match.index,
          end: match.index + match[0].length,
          raw: match[0],
          jid: decodeURIComponent(match[2]),
          label: decodeURIComponent(match[3]),
        },
      ];
    } catch (_) {
      return [];
    }
  });
}
